import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import relatedProductsReducer from './relatedProductsReducer'
import { productTypes } from 'actions/types'

const initialState = null
const baseType = productTypes.FETCH_PRODUCT

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
  relatedProducts: relatedProductsReducer,
})

export default reducer
